# feature bits turn on or off different functional features within the application
window.phr.constant('FEATURE_BITS', {
  biDirectionalAppointments: true,
  isHealthRecordsOverviewOn: true
})
